<template>
	<div class="full" style="background-color: white;">
		<el-form class="full" ref="form" :model="form" label-width="80px" v-loading="loading"
			element-loading-background="rgba(255, 255, 255, 0.5)">
			<el-divider content-position="left">材质</el-divider>
			<el-form-item label="">
				<el-checkbox-group v-model="form.identifymaterial" size="mini">
					<el-checkbox-button v-for="(item,index) in attr.identifymaterial" :label="item.id" name="type"
						:key="index">{{item.name}}</el-checkbox-button>
				</el-checkbox-group>
			</el-form-item>
			<el-divider content-position="left">头型</el-divider>
			<el-form-item label="">
				<el-checkbox-group v-model="form.identifyheadshape" size="mini">
					<el-checkbox-button v-for="(item,index) in attr.identifyheadshape" :label="item.id" name="type"
						:key="index">{{item.name}}</el-checkbox-button>
				</el-checkbox-group>
			</el-form-item>
			<el-divider content-position="left">槽型</el-divider>
			<el-form-item label="">
				<el-checkbox-group v-model="form.identifygroovetype" size="mini">
					<el-checkbox-button v-for="(item,index) in attr.identifygroovetype" :label="item.id" name="type"
						:key="index">{{item.name}}</el-checkbox-button>
				</el-checkbox-group>
			</el-form-item>
			<el-divider content-position="left">大类</el-divider>
			<el-form-item label="">
				<el-checkbox-group v-model="form.identifyclass" size="mini">
					<el-checkbox-button v-for="(item,index) in attr.identifyclass" :label="item.id" name="type"
						:key="index">{{item.name}}</el-checkbox-button>
				</el-checkbox-group>
			</el-form-item>
			<el-divider content-position="left">镀层</el-divider>
			<el-form-item label="">
				<el-checkbox-group v-model="form.identifycladding" size="mini">
					<el-checkbox-button v-for="(item,index) in attr.identifycladding" :label="item.id" name="type"
						:key="index">{{item.name}}</el-checkbox-button>
				</el-checkbox-group>
			</el-form-item>
			<el-form-item>
				<el-button style="float: right;" type="success" @click="onSubmit" size="mini">保存</el-button>
			</el-form-item>
		</el-form>
	</div>

</template>
<style scoped>

</style>
<script>
	export default {
		props: {
			name: {
				default: () => {
					return ''
				}
			},
			emunid: {
				default: () => {
					return 0
				}
			},
		},
		data() {
			return {
				loading: false,
				attr: {
					identifymaterial: [],
					identifyheadshape: [],
					identifygroovetype: [],
					identifyclass: [],
					identifycladding: [],
				},
				form: {
					identifymaterial: [],
					identifyheadshape: [],
					identifygroovetype: [],
					identifyclass: [],
					identifycladding: [],
				},
			}
		},
		watch: {
			emunid() {
				this.get()
			}
		},
		created() {
			let field = []
			for (let i in this.attr) {
				field.push(i)
			}
			this.$api.emunlist.list({
				field: field.join(',')
			}).then((res) => {
				res.forEach((item) => {
					this.attr[item.field].push(item)
				})
			})
			this.get()
		},
		mounted() {

		},
		computed: {

		},

		methods: {
			get() {
				if (!this.emunid) {
					this.$message.error('请选择商品')
					return
				}
				this.loading = true
				this.$api.emunextend_goodstype.get(this.emunid).then((res) => {
					this.loading = false
					if (res) {
						for (let i in this.form) {
							this.form[i] = res[i]
						}
					} else {
						for (let i in this.form) {
							this.form[i] = []
						}
					}
				})
			},
			onSubmit() {
				if (!this.emunid) {
					this.$message.error('请选择商品')
					return
				}
				this.form.emunvalueid = this.emunid
				this.$api.emunextend_goodstype.save(this.form).then(() => {
					this.$message.success('操作成功')
				})

			},
		},
		components: {
	

		}
	}
</script>